import React, {Component} from "react";
import {connect} from "react-redux";
import {TenderChange} from "../../../../redux/actions/Cart.Action";

class Cash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      change: 0,
      cashin: 0,
      cartTotal: this.props.CurrentCart.total,
      split: 1,
      splitText: "",
    };

    this.props.TenderChange(0, 0);
  }
  CalculateTender(tender, action) {
    var old = this.state.cashin;
    const total = parseFloat(this.state.cartTotal);
    var newcashin = 0;
    var changecash = 0;
    if (old === 0) {
      old = "";
    }
    if (action === "add") {
      newcashin = parseFloat(old ? old : 0) + parseFloat(tender);
    } else {
      newcashin = parseFloat(old + tender);
    }
    changecash = parseFloat(newcashin - total).toFixed(2);
    this.props.TenderChange(newcashin, changecash);
    this.setState({
      cashin: newcashin,
      change: (parseFloat(newcashin) - total).toFixed(2),
    });
  }
  SplitPayment() {
    let currentper = this.state.split + 1;
    if (currentper > 6) {
      currentper = 2;
    }
    const newspilit = (parseFloat(this.state.cartTotal) / currentper).toFixed(
      2
    );
    this.setState({
      split: currentper,
      splitText: newspilit + " For " + currentper,
    });
  }
  render() {
    return (
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-around">
            <span className="text-danger fs-3 pb-3">
              Change रु {this.props.CurrentCart.change}
            </span>
            <span className="text-warning fs-5">
              Tender रु {this.props.CurrentCart.tender}
            </span>
          </div>
        </div>
        <div className="row">
          {/* <div className="col-4 mt-10">
                  <span className="text-warning fs-5">
                    Tender
                    <br /> रु {this.props.CurrentCart.tender}
                  </span>
                  <br />
                  <label
                    className="btn w-100 btn-multiline btn-secondary"
                    onClick={(e) => this.SplitPayment()}
                  >
                    <img src={spliticon} alt="splitiicon" />
                    <br />
                    Split
                  </label>
                  <h4 className="text-center">{this.state.splitText}</h4>
                </div> */}
          <div className="col-md-6 text-center">
            <label
              className="m-2 btn btn-w-sm btn-multiline btn-secondary align-self-center"
              onClick={(e) => this.CalculateTender(5, "add")}
            >
              5
            </label>
            <label
              className="m-2 btn btn-w-sm btn-multiline btn-primary align-self-center"
              onClick={(e) => this.CalculateTender(10, "add")}
            >
              10
            </label>
            <label
              className="m-2 btn btn-w-sm btn-multiline btn-warning align-self-center"
              onClick={(e) => this.CalculateTender(50, "add")}
            >
              50
            </label>
            <label
              className="m-2 btn btn-w-sm btn-multiline btn-success align-self-center"
              onClick={(e) => this.CalculateTender(100, "add")}
            >
              100
            </label>
            <label
              className="m-2 btn btn-w-sm btn-multiline btn-info align-self-center"
              onClick={(e) => this.CalculateTender(500, "add")}
            >
              500
            </label>
            <label
              className="m-2 btn btn-w-sm btn-multiline btn-danger align-self-center"
              onClick={(e) => this.CalculateTender(1000, "add")}
            >
              1000
            </label>
          </div>
          <div className="col-md-6 d-flex justify-content-center">
            <div className="btn-group-vertical">
              <div className="btn-group">
                <input
                  className="text-center form-control mb-2 w-100"
                  value={this.state.cashin}
                  readOnly
                />
              </div>
              <div className="btn-group">
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("7")}
                >
                  7
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("8")}
                >
                  8
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("9")}
                >
                  9
                </label>
              </div>
              <div className="btn-group">
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("4")}
                >
                  4
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("5")}
                >
                  5
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("6")}
                >
                  6
                </label>
              </div>
              <div className="btn-group">
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("1")}
                >
                  1
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("2")}
                >
                  2
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("3")}
                >
                  3
                </label>
              </div>
              <div className="btn-group">
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender("0")}
                >
                  0
                </label>
                <label
                  className="btn btn-lg btn-outline-secondary py-3"
                  onClick={(e) => this.CalculateTender(".")}
                >
                  .
                </label>
                <label
                  className="btn btn-lg btn-info py-3"
                  onClick={(e) => {
                    this.setState({ cashin: 0, change: 0 });
                    this.props.TenderChange(0, 0);
                  }}
                >
                  Clear
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    CurrentCart: state.Cart.CurrentCart,
  }),
  { TenderChange }
)(Cash);
